import React from 'react';
import styled from 'styled-components';
import { InputErrors } from './WithErrors';

type InputErrorsProps = React.ComponentProps<typeof InputErrors>['errors'];

type Props = {
  className?: string;
  checked?: boolean;
  setChecked?: (checked: boolean) => void;
  errors?: InputErrorsProps;
  noErrors?: boolean;
} & React.InputHTMLAttributes<HTMLInputElement>;

const Input = styled.input``;

const CheckBox = ({
  className = '',
  checked = false,
  setChecked,
  errors,
  noErrors = false,
  ...rest
}: Props) =>
  noErrors ? (
    <Input
      type="checkbox"
      className={className}
      checked={checked}
      onChange={(e) => setChecked?.(e.target.checked)}
      {...rest}
    />
  ) : (
    <InputErrors errors={errors}>
      <Input
        type="checkbox"
        className={className}
        checked={checked}
        onChange={(e) => setChecked?.(e.target.checked)}
        {...rest}
      />
    </InputErrors>
  );

export default styled(CheckBox)``;
